import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import ContagemEstoque from '../pages/ContagemEstoque';
import GestoresBI from '../pages/GestoresBI';
import GestoresUtilitarios from '../pages/GestoresUtilitarios';
import GestorFood from '../pages/GestorFood';
import GestorPosCloverPrivacy from '../pages/GestorPos/index-clover.js';
import GestorPosLicenseAgreement from '../pages/GestorPos/index-license-agreement.js';
import GestorPosto from '../pages/GestorPosto';

import GTefCloverPrivacy from '../pages/GTef/index-clover.js';
import GTefLicenseAgreement from '../pages/GTef/index-license-agreement.js';

import GestorAuth from '../pages/GestorAuth';

export const Routes = () => {
	const router = createBrowserRouter([
		{
			path: '/ContagemEstoque',
			element: <ContagemEstoque />,
		},
		{
			path: '/GestorPosCloverPrivacy',
			element: <GestorPosCloverPrivacy />,
		},
		{
			path: '/GTefCloverPrivacy',
			element: <GTefCloverPrivacy />,
		},
		{
			path: '/GestorPosLicenseAgreement',
			element: <GestorPosLicenseAgreement />,
		},
		{
			path: '/GTefLicenseAgreement',
			element: <GTefLicenseAgreement />,
		},
		{
			path: '/GestoresUtilitarios',
			element: <GestoresUtilitarios />,
		},
		{
			path: '/GestoresBI',
			element: <GestoresBI />,
		},
		{
			path: '/GestorFood',
			element: <GestorFood />,
		},
		{
			path: '/GestorPosto',
			element: <GestorPosto />,
		},
		{
			path: '/GestorAuth',
			element: <GestorAuth />,
		},
	]);
	return <RouterProvider router={router} />;
};

export default Routes;
